import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/web.timers.js";
// Fonction de gestion du DomReady, passé ou futur
export var DOMReady = function DOMReady(start) {
  DOMContentLoaded(start);
};
var DOMContentLoaded = function DOMContentLoaded(start) {
  if (/comp|inter|loaded/.test(document.readyState)) {
    // In case DOMContentLoaded was already fired, the document readyState will be one of "complete" or "interactive" or (nonstandard) "loaded".
    // The regexp above looks for all three states. A more readable regexp would be /complete|interactive|loaded/
    setTimeout(start, 0);
  } else {
    // In case DOMContentLoaded was not yet fired, use it to run the "start" function when document is read for it.
    document.addEventListener('DOMContentLoaded', start, false);
  }
};